document.addEventListener("DOMContentLoaded", function () {
	gsap.registerPlugin(ScrollTrigger);

	// デバイスごとの要素を取得
	const devices = [
		{ imageClass: ".pc-image", videoClass: ".pc-video", trigger: ".visual-pc" }, // PC用
		{ imageClass: ".sp-image", videoClass: ".sp-video", trigger: ".visual-sp" }, // SP用
	];

	devices.forEach((device) => {
		const staticImage = document.querySelector(device.imageClass);
		const dynamicVideo = document.querySelector(device.videoClass);

		if (staticImage && dynamicVideo) {
			// 動画を初期状態で停止
			dynamicVideo.pause();

			// GSAPタイムライン設定
			gsap.timeline({
				scrollTrigger: {
					trigger: device.trigger, // 各デバイスのトリガー要素
					start: "top top", // アニメーション開始位置
					end: "top -100px", // アニメーション終了位置
					scrub: true, // スクロールに連動
					markers: false, // デバッグ用マーカー（不要ならfalse）
				},
			})
				.to(staticImage, { opacity: 0, duration: 1.5 }, 0) // 静止画をフェードアウト
				.to(
					dynamicVideo,
					{
						opacity: 1,
						duration: 1.5,
						onStart: () => {
							dynamicVideo.play(); // 動画を再生
						},
						onReverseComplete: () => {
							dynamicVideo.pause(); // スクロールを戻した時に動画を停止
						},
					},
					0
				);
		}
	});
});
